module.exports = __webpack_public_path__ + "static/fonts/fons_3.26875b7.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/font/fons_3.ttf
// module id = bO7M
// module chunks = 1